module.exports = __webpack_public_path__ + "img/prize-04-pic.bc20e8c7.png";